import { styled } from "styled-components";

export const PageHeader = styled.div`
	padding: 20px 0;
`;

export const CardWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 12px 0 36px;

	.chartCard,
	& > div {
		width: 48%;
		padding-left: 20px;
		padding-right: 20px;
	}
`;
